import SubscribableEvent from 'subscribableevent';

export function createEvent<T extends (...args: any[]) => boolean | void>() {
  return new SubscribableEvent<T>();
}
